import { UploadButton } from '@bytescale/upload-widget-react';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import { ProfilePicture } from 'components/common/ProfilePicture';
import React, { useEffect, useState } from 'react'
import { Controller, FormProvider, useForm } from 'react-hook-form';
import PhoneInput from 'components/common/PhoneInput';
import { useDispatch, useSelector } from 'react-redux';
import { cdn } from 'constants/common';
import { setError } from 'slices/userSlice';
import toast from 'react-hot-toast';
import FullPageLoader from 'components/common/FullPageLoader';
import { Switch } from '@mui/material';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { CustomSwitch } from 'components/common/Switch';
import { fetchStates } from 'slices/stateSlice';
import { Select } from 'components/common/Select';
import { stateSelector } from 'slices/stateSlice';
import { fetchLanguages } from 'slices/languageSlice';
import { interpreterProfileSelector } from 'slices/interpreter/profileSlice';
import { fetchInterpreterProfile } from 'slices/interpreter/profileSlice';
import { updateInterpreterProfile } from 'slices/interpreter/profileSlice';
import { citySelector } from 'slices/citySlice';
import { fetchCountries } from 'slices/countrySlice';
import { fetchTimezone } from 'slices/timezoneSlice';
import { USA } from "constants/common";
import VerificationDocuments from 'components/interpreter/VerificationDocuments';
import { useTranslation } from 'react-i18next';
import Api from 'services/api';

const appendFormData = (formData, value, key) => {
    if (value instanceof File) {
        formData.append(key, value);
        return;
    }

    if (Array.isArray(value)) {
        value.forEach((entry, index) => appendFormData(formData, entry, `${key}[${index}]`));
        return;
    }

    if (value && typeof value === 'object') {
        Object.entries(value).forEach(([childKey, childValue]) => {
            appendFormData(formData, childValue, key ? `${key}[${childKey}]` : childKey);
        });
        return;
    }

    if (value !== undefined && value !== null) {
        formData.append(key, typeof value === 'boolean' ? (value ? '1' : '0') : value);
    }
};

const ShowProfile = ({ item, handleEdit }) => {
    const { t } = useTranslation();

    const InfoRow = ({ label, value }) => (
        <tr>
            <td className='col-3'><strong>{label}</strong></td>
            <td className='col-9'>{value || t("common.nA")}</td>
        </tr>
    );



    const isAgency = item?.vendor_type === 'agency';
    const isStaff = item?.user?.internal_interpreter == 1;
    const showNotificationSettings = !isAgency && !isStaff;

    const DEFAULT_NOTIFICATION_MODALITIES = {
        opi: true,
        vri: true,
        in_person: true,
    };

    const [notificationModalities, setNotificationModalities] = useState(() => {
        try {
            const saved = localStorage.getItem("notification_modalities");
            if (saved) {
                return { ...DEFAULT_NOTIFICATION_MODALITIES, ...JSON.parse(saved) };
            }
        } catch (e) {
            console.error("Failed to parse notification_modalities from storage", e);
        }
        return item?.user?.notification_modalities || DEFAULT_NOTIFICATION_MODALITIES;
    });

    useEffect(() => {
        if (item?.user?.notification_modalities) {
            setNotificationModalities((prev) => ({
                ...prev,
                ...item.user.notification_modalities,
            }));
        }
    }, [item?.user?.notification_modalities]);

    const handleModalityToggle = async (key, checked) => {
        const updated = { ...notificationModalities, [key]: checked };
        setNotificationModalities(updated);
        try {
            localStorage.setItem("notification_modalities", JSON.stringify(updated));
        } catch (e) {}

        try {
            await Api.updateNotificationModalities({ [key]: checked });
        } catch (err) {
            console.error("Failed to update notification modality", err);
        }
    };

    return (
        <div className='container_main mt-4 profile-container'>
            <div className="profile-header">
                <div className="profile-image">
                    {/* <ProfilePicture imageUrl="/images/default-person.png" /> */}
                    <ProfilePicture imageUrl={item?.user?.image ? (cdn + item?.user?.image) : '/images/default-person.png'} />
                </div>
                <div className="profile-info">
                    <h1 className='text-capitalize'>{item?.user?.name}</h1>
                    <p>{item?.address}</p>
                    <div className="edit_prof">
                        <button type='button' className='main_button' onClick={handleEdit}>
                            <i className="fa-solid fa-pen-to-square"></i>&nbsp;&nbsp;
                            <span>{t("profile.editProfile")}</span>
                        </button>
                    </div>
                </div>
            </div>

            <div className="profile-section">
                <h2>{t("profile.personalInformation")}</h2>
                <table>
                    <InfoRow label={t("profile.interpreterCode")} value={item?.code} />
                    <InfoRow label={t("profile.firstName")} value={item?.first_name} />
                    <InfoRow label={t("profile.lastName")} value={item?.last_name} />
                    <InfoRow label={t("profile.email")} value={item?.user?.email} />
                    <InfoRow label={t("profile.secondaryEmail")} value={item?.secondary_email} />
                    <InfoRow label={t("profile.cellPhone")} value={item?.phone} />
                    <InfoRow label={t("profile.secondaryCellPhone")} value={item?.secondary_number} />
                    <InfoRow label={t("profile.whatsappNumber", "WhatsApp Number:")} value={item?.whatsapp_number} />
                    <InfoRow label={t("profile.country")} value={item?.country?.name} />
                    {item?.country?.name && item?.country?.name == USA && (
                        <>
                    <InfoRow label={t("profile.state")} value={item?.state?.name} />
                    <InfoRow label={t("profile.cityName")} value={item?.city_name} />
                    <InfoRow label={t("profile.zipCode")} value={item?.zip_code} />
                        </>
                    )}
                    <InfoRow label={t("profile.timezone")} value={item?.timezone?.display_name} />
                    <InfoRow label={t("profile.languages")} value={item?.languages?.map(f => f?.language?.name).join(', ')} />
                    <InfoRow label={t("profile.address")} value={item?.address} />
                    {/* <InfoRow label="Role:" value="Interpreter" /> */}
                </table>
            </div>

            {showNotificationSettings && (
                <div className="profile-section" style={{ marginTop: "25px" }}>
                    <h2>{t("profile.notificationSettings", "Notification Settings")}</h2>
                    <table>
                        <tbody>
                            <tr>
                                <td className="col-3">
                                    <strong>{t("profile.opi", "OPI:")}</strong>
                                </td>
                                <td className="col-9">
                                    <CustomSwitch
                                        checked={notificationModalities.opi}
                                        handleChange={(checked) => handleModalityToggle("opi", checked)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="col-3">
                                    <strong>{t("profile.vri", "VRI:")}</strong>
                                </td>
                                <td className="col-9">
                                    <CustomSwitch
                                        checked={notificationModalities.vri}
                                        handleChange={(checked) => handleModalityToggle("vri", checked)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="col-3">
                                    <strong>{t("profile.inPerson", "In Person:")}</strong>
                                </td>
                                <td className="col-9">
                                    <CustomSwitch
                                        checked={notificationModalities.in_person}
                                        handleChange={(checked) => handleModalityToggle("in_person", checked)}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}

        </div>
    );
};


const Profile = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { register, handleSubmit, watch, formState: { errors }, control, setValue, clearErrors } = useForm({
        defaultValues: {
            attachments: [],
        },
    });
    const { interpreterProfile: item, error, loader } = useSelector(interpreterProfileSelector);
    const { state: states } = useSelector(stateSelector);
    const { city: cities } = useSelector(citySelector);
    const [activeEdit, setActiveEdit] = useState(false)
    const [credentialsSend, setCredentialsSend] = useState(0);
    const [autoAssign, setAutoAssign] = useState(false);
    const [localImage, setLocalImage] = React.useState('')
    const [allStates, setAllStates] = useState([]);
    const [filterStates, setfilterStates] = useState({
        label: "",
        value: ""
    })
    const [allCountries, setAllCountries] = useState([]);
      const [filterCountries, setfilterCountries] = useState({
        label: "",
        value: ""
      })
      const [availableTimezones, setAvailableTimezones] = useState([]);
      const [filterTimezones, setFilterTimezones] = useState({
        label: "",
        value: ""
      })
      const [timezoneDisable, setTimezoneDisable] = useState(false);
    
      const country_name = filterCountries?.label || '';
    
      const country_id = filterCountries?.value || '';
      const state_id = watch("state_id") ?? item?.state_id;

    useEffect(() => {
        Promise.allSettled(
            [dispatch(fetchInterpreterProfile())]
        )
    }, [])

    useEffect(() => {
        setValue('first_name', item?.first_name || '');
        setValue('last_name', item?.last_name || '');
        setValue('address', item?.address || '');
        setValue('email', item?.user?.email || '')
        setValue('phone', item?.phone || '');
        setValue('secondary_number', item?.secondary_number || undefined);
        setValue('whatsapp_number', item?.whatsapp_number || undefined);
        setValue('secondary_email', item?.secondary_email || undefined);
        setValue('zip_code', item?.zip_code || '');

        setCredentialsSend((typeof (item?.user?.credentials_send) == "number") ? item?.user?.credentials_send : 0);
        setAutoAssign((typeof (item?.auto_assign) == "number") ? item?.auto_assign : 0);

        setValue('us_based', item?.filters?.us_based == 1 ? 1 : 0);
        setValue('non_us_based', item?.filters?.non_us_based == 1 ? 1 : 0);
        setValue('english_to_target', item?.filters?.english_to_target == 1 ? 1 : 0);
        setValue('spanish_to_target', item?.filters?.spanish_to_target == 1 ? 1 : 0);
        setValue('court_certified', item?.filters?.court_certified == 1 ? 1 : 0);
        setValue('medical_certified', item?.filters?.medical_certified == 1 ? 1 : 0);

        setValue("language_ids", item?.languages?.map(language => language.language_id) || [])
        setValue('country_id', item?.country_id)
        dispatch(setError({}));

    }, [item, activeEdit, setValue])

    useEffect(() => {
        setValue(
        "vendor_agreement_expiry",
        item?.vendor_agreement_expiry
            ? String(item.vendor_agreement_expiry).split(/[T ]/)[0]
            : ""
        );
        if (states?.length > 0) {
            if (item?.state_id)
                setValue("state_id", item?.state_id)
        }
        else setValue("state_id", "")

        if (item?.city_name) {
            setValue("city_name", item?.city_name)
        }
        else {
            setValue("city_name", "")
        }

    }, [item, cities, states]);


    const submitCallback = (status, message) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            dispatch(fetchInterpreterProfile())
            handleCancelEdit()
        }
        else {
            console.log('onSubmit', error)
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };

    const onSubmit = (data) => {
        dispatch(setError({}))
        data = {
            ...data,
            credentialsSend,
            autoAssign,
        };

        const formData = new FormData();
        Object.entries(data).forEach(([key, value]) => appendFormData(formData, value, key));

        dispatch(updateInterpreterProfile(formData, submitCallback));
    }

    const options = {
        apiKey: "free",
        maxFileCount: 1
    };




    function handleEdit() {
        dispatch(fetchInterpreterProfile())
        setActiveEdit(true)
    }
    function handleCancelEdit() {
        dispatch(fetchInterpreterProfile())
        setActiveEdit(false)
    }





  // #region Country dropdown

   useEffect(() => {
    dispatch(fetchCountries(1, { id: item?.country?.id }))
    if (item?.country?.name && item?.country?.id) {
      setfilterCountries({
        label: item?.country?.name || "",
        value: item?.country?.id || ""
      })
    } else {
      setfilterCountries(null)
    }
  }, [item?.country])
  

  const filteredCountriesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchCountries(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
  
    setAllCountries(result?.data)
    return {
      options: result.data.map(val => ({
        value: val.id,
        label: val.name,
      })),

      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion


    // #region States dropdown

    useEffect(() => {
        dispatch(fetchStates(1, { id: item?.state?.id }))
        if (item?.state?.name && item?.state?.id) {
            setfilterStates({
                label: item?.state?.name || "",
                value: item?.state?.id || ""
            })
        } else {
            setfilterStates(null)
        }
    }, [item?.state])


    const filteredStatesLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchStates(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        setAllStates(result?.data)
        return {
            options: result.data.map(val => ({
                value: val.id,
                label: val.name,
            })),

            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };
    //#endregion



  // #region Timezone dropdown
  


useEffect(() => {
  const fetchAndSetTimezone = async () => {
  

    if (!country_name) {
      setAvailableTimezones([]);
      setFilterTimezones(null);
      setValue("timezone_id", "");
      setTimezoneDisable(false);
      return;
    }

    try {
      const response = await dispatch(
        fetchTimezone(1, { country_id, state_id }, true, true)
      );
      const timezones = response?.data || [];

      const tzOptions = timezones.map(tz => ({
        value: tz.id,
        label: tz.display_name,
      }));

      setAvailableTimezones(tzOptions);

      // US selected, state also selected
      if (country_name === USA && state_id) {
        
        if (tzOptions.length === 1) {
          setFilterTimezones(tzOptions[0]);
          setValue("timezone_id", tzOptions[0].value);
          setTimezoneDisable(true);
        } else {
          setFilterTimezones(null);
          setValue("timezone_id", "");
          setTimezoneDisable(false);
        }
      }
      // US selected, no state selected
      else if (country_name === USA) {
        
    
        setFilterTimezones(null);
        setValue("timezone_id", "");
        setTimezoneDisable(false);
      }
      // Any other country
      else {
        if (tzOptions.length === 1) {
          setFilterTimezones(tzOptions[0]);
          setValue("timezone_id", tzOptions[0].value);
          setTimezoneDisable(true);
        } else {
          setFilterTimezones(null);
          setValue("timezone_id", "");
          setTimezoneDisable(false);
        }
      }

    } catch (error) {
      console.error("Timezone fetch error:", error);
      setAvailableTimezones([]);
      setFilterTimezones(null);
      setValue("timezone_id", "");
      setTimezoneDisable(false);
    }
  };

  fetchAndSetTimezone();
}, [filterCountries, filterStates, setValue, dispatch]);



  // Load options function (API call to timezone endpoint)
const filteredTimezonesLoadOptions = async (inputValue, loadedOptions, { page }) => {
  

  const result = await dispatch(
    fetchTimezone(
      page,
      {
        pageLength: 10,
        sortBy: "id",
        sortDirection: "asc",
        search: inputValue,
        country_id,
        state_id,
      },
      true,
      true
    )
  );

  return {
    options: result.data.map(val => ({
      value: val.id,
      label: val.display_name,
    })),
    hasMore: page !== result?.last_page,
    additional: {
      page: page + 1,
    },
  };
};




  //#endregion

    // #region City dropdown
    const [allCities, setAllCities] = useState([])
    const [selectedCity, setSelectedCity] = useState({
        label: "",
        value: ""
    })
    const filteredCities = React.useMemo(() =>
        allCities?.map(val => {
            const object = {
                label: item?.city?.name || val.name,
                value: item?.city?.id || val.id,
            }
            return object
        }), [allCities, item?.city]);


    const filteredStates = React.useMemo(() => {

        setAllCities(item?.state?.name != null ? states?.find(state => state?.name == item?.state?.name)?.cities : [])
        return states?.map(item => {
            const object = {
                label: item?.name,
                value: item?.id,
            }
            return object
        })
    }, [states, item?.state?.name]);

    useEffect(() => {
        setSelectedCity(filteredCities)
    }, [filteredCities])

    useEffect(() => {
        if (item?.city?.name && item?.city?.id) {
            setSelectedCity({
                label: item?.city?.name || "",
                value: item?.city?.id || ""
            })
        } else {
            setSelectedCity(null)
        }
    }, [item?.city])

    //#endregion


    // #region Language dropdown
    const [languageState, setLanguageState] = useState({
        label: "",
        value: ""
    })

    useEffect(() => {
        setLanguageState(
            item?.languages?.map(val => ({
                label: val?.language?.name || "",
                value: val?.language?.id || ""
            }))
        );
    }, [item?.languages]);


    const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        return {
            options: result?.data?.map(language => ({
                value: language.id,
                label: language.name,
            })),
            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };
    //#endregion

    const handleChangeSwitch = (checked, onChange) => {
        onChange(checked ? 1 : 0); // convert true => 1, false => 0
      };
      
     
    return (
        <div className="content">
            <div className="row_main_head">
                {/* <h2 className="main_heading">Profile Page</h2> */}
            </div>
            {activeEdit === false ?
                <ShowProfile item={item} handleEdit={handleEdit} />
                :
                <div className='container_main mt-4'>
                    <form className='card_table' onSubmit={handleSubmit(onSubmit)}>

                        {/* Main credientials area  */}
                        <div className="row-primary">
                            <h2>{t("profile.profilePicture")}</h2>

                            <div className='Upload_wrapper'>
                                {(localImage || item?.user?.image) &&
                                    <div className='image_preview'>
                                        <ProfilePicture imageUrl={localImage || (cdn + item?.user?.image) || '/images/default-person.png'} />
                                    </div>
                                }
                                <div className='w-100'>
                                    <Controller name="image" control={control} render={({ field }) =>
                                    (
                                        <UploadButton options={options}
                                            onComplete={files => {
                                                const file = files[0];
                                                setLocalImage(file?.fileUrl);
                                                field.onChange(file?.originalFile?.file);
                                            }}>
                                            {({ onClick }) =>
                                                <button type='button' onClick={onClick}>
                                                    <i className="fa-solid fa-camera"></i>&nbsp;&nbsp;
                                                    <span>{t("profile.uploadNew")}</span>
                                                </button>
                                            }
                                        </UploadButton>
                                    )}
                                    />
                                    {error?.errors?.image?.map((error) => (
                                        <div style={{ marginBottom: 10 }}>
                                            <ErrorMessage text={error} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className='template foam_page_row'>

                            <div className="row-primary">
                                <h2>{t("profile.firstNameRequired")}</h2>
                                <Controller
                                    name="first_name"
                                    rules={{
                                        required: t("profile.firstNameRequired"),
                                    }}
                                    control={control}
                                    render={({ field }) =>
                                        <div className="w-100">
                                            <input className="input-in type_inp" type="text" name='first-name' placeholder='First name' {...field} />
                                            {error?.errors?.first_name?.length > 0 && (
                                                error?.errors?.first_name?.map((error) => <ErrorMessage text={error} />)
                                            )}
                                            {errors?.first_name?.message &&
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={errors?.first_name?.message} />
                                                </div>
                                            }
                                        </div>
                                    }
                                />
                            </div>

                            <div className="row-primary">
                                <h2>{t("profile.lastName")}</h2>
                                <Controller
                                    name="last_name"
                                    control={control}
                                    render={({ field }) => <input className="input-in type_inp" type="text" name='last-name' placeholder='Last name' {...field} />}
                                />
                            </div>

                            <div className="row-primary">
                                <h2>{t("profile.emailRequired")}</h2>
                                <Controller
                                    name="email"
                                    rules={{
                                        required: t("profile.emailRequired"),
                                    }}
                                    control={control}
                                    render={({ field }) =>
                                        <div className='w-100'>
                                            <input className={`input-in type_inp ${error?.errors?.email ? "border-red" : ""} `} type="email" name='email'
                                                pattern={
                                                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                                }
                                                placeholder="Email Address"
                                                {...field}
                                            />
                                            {error?.errors?.email?.map((error) => (
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={error} />
                                                </div>
                                            ))}
                                            {errors?.email?.message &&
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={errors?.email?.message} />
                                                </div>
                                            }
                                        </div>
                                    }
                                />
                            </div>

                            <div className="row-primary">
                                <h2>{t("profile.phoneNumberRequired")}</h2>

                                <Controller
                                    name="phone"
                                    control={control}
                                    rules={{
                                        required: t("profile.phoneNumberRequired")
                                    }}
                                    render={({ field }) =>
                                        <div className='w-100'>
                                            <PhoneInput className="input-in type_inp" type="tel" name='phone' placeholder='Phone number' {...field} />
                                            {error?.errors?.phone?.map((error) => (
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={error} />
                                                </div>
                                            ))}
                                            {errors?.phone?.message &&
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={errors?.phone?.message} />
                                                </div>
                                            }
                                        </div>
                                    }
                                />
                            </div>

                            <div className="row-primary">
                                <h2>{t("profile.secondaryEmail")}</h2>
                                <Controller
                                    name="secondary_email"
                                    control={control}
                                    render={({ field }) => <input className={`input-in type_inp ${error?.errors?.secondary_email ? "border-red" : ""} `} type="email" name='secondary_email'
                                        pattern={
                                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                        }
                                        placeholder="Secondary email"
                                        {...field}
                                    />}
                                />
                            </div>

                            <div className="row-primary">
                                <h2>{t("profile.secondaryCellPhone")}</h2>
                                <Controller
                                    name="secondary_number"
                                    control={control}
                                    render={({ field }) =>
                                        <PhoneInput className="input-in type_inp" type="tel" name='phone' placeholder='Phone number' {...field} />
                                    }
                                />
                            </div>

                            <div className="row-primary">
                                <h2>{t("profile.whatsappNumber", "WhatsApp Number:")}</h2>
                                <Controller
                                    name="whatsapp_number"
                                    control={control}
                                    render={({ field }) =>
                                        <PhoneInput className="input-in type_inp" type="tel" name='whatsapp_number' placeholder={t('profile.whatsappNumberPlaceholder', 'WhatsApp Number')} {...field} />
                                    }
                                />
                            </div>

                            <div className="row-primary">
                                <h2>{t("profile.selectCountryRequired")}</h2>
                    
                                <Controller
                                    name="country_id"
                                    control={control}
                                    rules={{
                                    required: "Please select a country",
                                    }}
                                    render={({ field }) => (
                                    <div style={{ width: "100%" }}>
                                        <AsyncPaginate
                                        menuPlacement="auto"
                                        styles={selectCustomStyles}
                                        value={filterCountries}
                                        loadOptions={filteredCountriesLoadOptions}
                                        isClearable
                                        escapeClearsValue
                                        onChange={(obj) => {
                                            setfilterCountries(obj);
                                            field.onChange(obj?.value);
                                            if (obj?.label != USA) {
                                            setValue("state_id", "");
                                            setValue("zip_code", "");
                                            }
                                        }}
                                        additional={{
                                            page: 1,
                                        }}
                                        />
                                        {errors?.country_id?.message && (
                                        <div style={{ marginBottom: 10 }}>
                                            <ErrorMessage text={errors?.country_id?.message} />
                                        </div>
                                        )}
                                    </div>
                                    )}
                                />
                            </div>
                            {country_name && country_name == USA && (
                                <>
                                <div className="row-primary">
                                    <h2>{t("profile.selectStateRequired")}</h2>

                                    <Controller
                                        name="state_id"
                                        control={control}
                                        rules={{
                                            required: "Please select a state"
                                        }}
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                <AsyncPaginate
                                                    menuPlacement='auto'
                                                    styles={{
                                                        ...selectCustomStyles,
                                                    }}
                                                    value={filterStates}
                                                    loadOptions={filteredStatesLoadOptions}
                                                    isClearable
                                                    escapeClearsValue
                                                    onChange={(obj) => {
                                                        setfilterStates(obj)
                                                        setAllCities(obj != null ? allStates?.find(states => states?.name == obj?.label)?.cities : [])
                                                        field.onChange(obj?.value);
                                                    }}
                                                    additional={{
                                                        page: 1,
                                                    }}
                                                />
                                                {errors?.state_id?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.state_id?.message} />
                                                    </div>
                                                }
                                            </div>
                                        }
                                    />
                                </div>

                                <div className="row-primary">
                                    <h2>{t("profile.cityNameRequired")}</h2>
                                    {/* <Controller name="city_id" control={control}
                                        rules={{
                                            required: "Please select a City"
                                        }}
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                <Select
                                                    name="city_id"
                                                    options={filteredCities || []}
                                                    {...field}
                                                    value={filterStates ?? item?.city ? (filteredCities?.find((opt) => field.value === opt.value) || []) : null} />
                                                {errors?.city_id?.message && <div style={{ marginBottom: 10 }}> <ErrorMessage text={errors?.city_id?.message} /> </div>}
                                            </div>
                                        }
                                    /> */}

                                    <Controller
                                        name="city_name"
                                        control={control}
                                        render={({ field }) => (
                                        <div className="w-100">
                                            <input
                                            className="input-in type_inp"
                                            type="text"
                                            name="city_name"
                                            placeholder="Enter City Name"
                                            {...field}
                                            />
                                            {errors?.city_name?.message && (
                                            <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={errors?.city_name?.message} />
                                            </div>
                                            )}
                                        </div>
                                        )}
                                    />
                                </div>

                                <div className="row-primary">
                                    <h2>{t("profile.zipCodeRequired")}</h2>
                                    <Controller
                                        name="zip_code"
                                        rules={{ required: 'Zip Code is required' }}
                                        control={control}
                                        render={({ field }) =>
                                            <div className='w-100'>
                                                <input className="input-in type_inp" type="text" name='zip_code' placeholder="Zip Code" {...field} />
                                                {errors?.zip_code?.message && <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={errors?.zip_code?.message} />
                                                </div>}
                                            </div>
                                        }
                                    />
                                </div>
                                </>
                                )}

                                      <div className="row-primary">
                                        <h2>{t("profile.timezone")}</h2>
                                        <Controller
                                          name="timezone_id"
                                          control={control}
                                          rules={{ required: "Please select a Timezone" }}
                                          render={({ field }) => (
                                            <div style={{ width: "100%" }}>
                                              <AsyncPaginate
                                                styles={selectCustomStyles}
                                                value={filterTimezones}
                                                loadOptions={filteredTimezonesLoadOptions}
                                                isClearable
                                                isDisabled={timezoneDisable}
                                                placeholder="Select Timezone"
                                                onChange={(selected) => {
                                                  setFilterTimezones(selected);
                                                  setValue("timezone_id", selected?.value || "");
                                                  field.onChange(selected?.value || "");
                                                }}
                                                additional={{ page: 1 }}
                                              />
                                              {errors?.timezone_id?.message && (
                                                <div style={{ marginBottom: 10 }}>
                                                  <ErrorMessage text={errors?.timezone_id?.message} />
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        />
                            
                                    </div>
                                    

                            <div className="row-primary">
                                <h2>{t("profile.selectLanguagesRequired")}</h2>
                                <Controller
                                    name="language_ids"
                                    required
                                    rules={{
                                        required: "Languages must be specified",
                                    }}
                                    control={control}
                                    render={({ field }) =>
                                        <div style={{ width: "100%" }}>
                                            <div style={{ width: "100%" }}>
                                                <AsyncPaginate
                                                    menuPlacement='auto'
                                                    isMulti
                                                    styles={{
                                                        ...selectCustomStyles,
                                                    }}
                                                    value={languageState}
                                                    loadOptions={filteredLanguagesLoadOptions}
                                                    isClearable
                                                    escapeClearsValue
                                                    onChange={(selected) => {
                                                        setLanguageState(selected)
                                                        field.onChange(selected.map((opt) => opt.value))
                                                    }}
                                                    additional={{
                                                        page: 1,
                                                    }}
                                                />
                                            </div>
                                            {errors?.language_ids?.message && <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={errors?.language_ids?.message} />
                                            </div>}
                                        </div>
                                    }
                                />
                            </div>

                            <div className="row-primary">
                                <h2>{t("profile.address")}</h2>
                                <Controller
                                    name="address"
                                    control={control}
                                    render={({ field }) => (
                                    <input
                                        className="input-in type_inp"
                                        type="text"
                                        name="last-name"
                                        placeholder="Address"
                                        {...field}
                                    />
                                    )}
                                />
                            </div>

                            {/* <div className="row-primary align-items-center">
                                <h2 className='m-0'>Credentials will be sent over email</h2>
                                <label className="custom-checkbox checkbox">
                                    <input
                                        type="checkbox"
                                        name="credentials_send"
                                        checked={credentialsSend === 1 ? true : false}
                                        onChange={(e) => setCredentialsSend(e.target.checked ? 1 : 0)}
                                    />
                                    <span className="checkmark"></span>
                                </label>
                            </div> */}

                            {/* <div className="row-primary align-items-center">
                                <h2 className='mt-0'>Auto Assign </h2>
                                <CustomSwitch
                                    labelText="auto_assign"
                                    checked={autoAssign == 1 ? true : false}
                                    handleChange={(checked) => setAutoAssign(checked ? 1 : 0)}
                                />
                            </div> */}
                        </div>

                        {/* filter area  */}
                        {/* <div className="row-primary row-r justify-content-between flex-row">
                            <h2 className='fst-italic'>Filters </h2>
                        </div>
                        <div className="Filter_wrapper">
                            <div className="row-primary">
                                <h2 className='col-6'>US Based Interpreter</h2>
                                <Controller
                                    name="us_based"
                                    control={control}
                                    render={({ field }) => (
                                        <div className="switch_row">
                                            <Switch
                                                checked={field.value == 1}
                                                onChange={(e) => handleChangeSwitch(e.target.checked, field.onChange)}
                                                value={true}
                                            />
                                        </div>
                                    )}
                                />
                            </div>


                            <div className="row-primary">
                                <h2 className='col-6'>Non US Based Interpreter</h2>
                                <Controller
                                    name="non_us_based"
                                    control={control}
                                    render={({ field }) => (
                                        <div className="switch_row">
                                            <Switch
                                                checked={field.value == 1}
                                                onChange={(e) => handleChangeSwitch(e.target.checked, field.onChange)}
                                                value={true}
                                            />
                                        </div>
                                    )}
                                />
                            </div>

                            <div className="row-primary">
                                <h2 className='col-6'>English To Target Language</h2>
                                <Controller
                                    name="english_to_target"
                                    control={control}
                                    render={({ field }) => (
                                        <div className="switch_row">
                                            <Switch
                                                checked={field.value == 1}
                                                onChange={(e) => handleChangeSwitch(e.target.checked, field.onChange)}
                                                value={true}
                                            />
                                        </div>
                                    )}
                                />
                            </div>

                            <div className="row-primary">
                                <h2 className='col-6'>Spanish To Target Language</h2>
                                <Controller
                                    name="spanish_to_target"
                                    control={control}
                                    render={({ field }) => (
                                        <div className="switch_row">
                                            <Switch
                                                checked={field.value == 1}
                                                onChange={(e) => handleChangeSwitch(e.target.checked, field.onChange)}
                                                value={true}
                                            />
                                        </div>
                                    )}
                                />
                            </div>

                            <div className="row-primary">
                                <h2 className='col-6'>Court Certified</h2>
                                <Controller
                                    name="court_certified"
                                    control={control}
                                    render={({ field }) => (
                                        <div className="switch_row">
                                            <Switch
                                                checked={field.value == 1}
                                                onChange={(e) => handleChangeSwitch(e.target.checked, field.onChange)}
                                                value={true}
                                            />
                                        </div>
                                    )}
                                />
                            </div>

                            <div className="row-primary">
                                <h2 className='col-6'>Medical Certified</h2>
                                <Controller
                                    name="medical_certified"
                                    control={control}
                                    render={({ field }) => (
                                        <div className="switch_row">
                                            <Switch
                                                checked={field.value == 1}
                                                onChange={(e) => handleChangeSwitch(e.target.checked, field.onChange)}
                                                value={true}
                                            />
                                        </div>
                                    )}
                                />
                            </div>
                        </div> */}

                        {/* filter area  */}    
                        <VerificationDocuments
                            item={item}
                            control={control}
                            errors={errors}
                            submitMode="deferred"
                        />

                        <div className="Form-footer">
                            <button type='button' className='Cancle_button' onClick={handleCancelEdit}>{t("confirmModal.cancel")}</button>
                            <SubmitButton btnText={t("profile.updateProfile")} loader={loader} />
                        </div>
                    </form>
                </div>
            }
            {loader && <FullPageLoader loader={loader} />}
        </div>
    )
}

export default Profile